import styled from 'styled-components'

type Props = {
	height: number
}

export const Placeholder = styled.div<Props>`
	height: ${({ height }) => height}px;
`
